module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "hidden-md-and-down"
  }, [(this.rowData.organisation) ? _c('el-col', {
    attrs: {
      "span": this.isManager() ? 18 : 24
    }
  }, [_c('contacts-popover', {
    attrs: {
      "row-data": _vm.rowData,
      "title": "Authority",
      "icon": "fa fa-gavel"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [(_vm.isManager('admin|finance|property')) ? _c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-982c2f58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/permits/PermitControls.vue
// module id = 1676
// module chunks = 0